import React, { ReactElement } from 'react';
import { useLocation, useParams } from 'react-router';
import { Heading, Loader } from 'idsk-react-components';
import Layout from '../Layout';
import './pripomienkaVyhodnotPage.scss';
import { usePripomienkaDetail } from '../../module/PripomienkaDetail';
import ClassType from '../../model/pripomienka/ClassType';
import routes from '../../routing/routes';
import VyhodnotenieForm from '../../module/VyhodnotenieForm';
import PripomienkaDetailComponent from '../../module/PripomienkaDetail/component/PripomienkaDetailComponent';
import UserRole from '../../model/currentuser/UserRole';
import SecuredPage from '../../module/SecuredPage';

interface Props {
  classType: ClassType;
}

export default ({ classType }: Props): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, uuid: string }>();
  const {
    pripomienkaDetail,
    pripomienkaStatus,
  } = usePripomienkaDetail({ classType });

  const { pathname } = useLocation();
  const getHeading = (): string => (classType === ClassType.HROMADNA_PRIPOMIENKA
    ? 'Vyhodnotiť hromadnú pripomienku'
    : 'Vyhodnotiť pripomienku');

  const getBackUrl = (): string => (classType === ClassType.HROMADNA_PRIPOMIENKA
    ? routes.hromadnePripomienky.list.withParams(type, year, index)
    : routes.pripomienky.list.withParams(type, year, index));

  return (
    <Layout
      isHromadna={classType === ClassType.HROMADNA_PRIPOMIENKA}
      breadcrumbRouteList={[{
        heading: classType === ClassType.HROMADNA_PRIPOMIENKA
          ? routes.hromadnePripomienky.evaluate.name
          : routes.pripomienky.evaluate.name,
        to: pathname,
      }]}
    >
      <SecuredPage allowForRoles={[UserRole.VYHODNOCOVATEL]} requestStatuses={[pripomienkaStatus?.responseCode]}>
        <div className="pripomienka-vyhodnot-page">
          <Heading size="l">
            {getHeading()}
          </Heading>
          <Loader loading={pripomienkaStatus?.loading}>
            <>
              <PripomienkaDetailComponent
                pripomienkaDetail={pripomienkaDetail}
              />
              <VyhodnotenieForm
                classType={classType}
                pripomienkaDetail={pripomienkaDetail}
                getBackUrl={getBackUrl}
              />
            </>
          </Loader>
        </div>
      </SecuredPage>
    </Layout>
  );
};
